import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import Header from './layout/Header';
import Footer from './layout/Footer';

const ProjectDetailPage = () => {
  const { id } = useParams();
  const [activeImage, setActiveImage] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  
  // Project data based on ID
  const projectData = {
    1: {
      title: "سامانه مدیریت موجودی و قیمت‌گذاری چندکاناله کورسل",
      breadcrumb: "سامانه کورسل (CoreSell)",
      brandName: "CORESELL",
      website: "coresell.ir",
      dedicatedLink: "/coresell",
      description: "سامانه یکپارچه مدیریت موجودی، قیمت‌گذاری و انبارداری چندکاناله (CoreSell) حاصل ۷ ماه تحقیق و توسعه مهندسی متمرکز در استودیو آلتو. این سامانه به طور ریشه‌ای مشکل مغایرت موجودی بین کانال‌های فروش همزمان (دیجی‌کالا، باسلام، فروشگاه اختصاصی ووکامرس) و نوسانات قیمت را حل کرده است. کورسل با تکیه بر معماری توزیع‌شده مبتنی بر صف‌های هوشمند BullMQ و Redis، وب‌هوک‌های لحظه‌ای، الگوریتم‌های قیمت‌گذاری هوشمند بر اساس کمیسیون، انبارداری دسته‌ای با اکسل و افزونه اختصاصی وردپرس، فرآیند فروش را کاملاً خودکار و پایدار کرده است.",
      images: [
        "./image/coresell1.jpg",
        "./image/coresell2.jpg",
        "./image/coresell3.jpg"
      ],
      client: "محصول اختصاصی استودیو آلتو",
      duration: "۷ ماه (۱۴۰۴-۱۴۰۵)",
      location: "اصفهان، ایران",
      technologies: ["Node.js", "Express", "BullMQ", "Redis", "React", "Tailwind CSS", "MongoDB", "WooCommerce Plugin", "Digikala Marketplace API", "Basalam API", "ExcelJS"],
      features: [
        "همگام‌سازی ثانیه‌ای موجودی با دیجی‌کالا، باسلام و سایت شخصی",
        "قیمت‌گذاری خودکار و درصدی بر اساس کارمزد و کمیسیون هر درگاه",
        "انبارگردانی دسته‌ای سریع با بارگذاری مستقیم فایل اکسل",
        "معماری مقاوم با صف‌های توزیع‌شده Redis و BullMQ بدون قطعی در شرایط اختلال اینترنت",
        "افزونه اختصاصی وردپرس (Stock Sync) برای همگام‌سازی دوطرفه با ووکامرس",
        "پیشگیری قطعی از جریمه‌های کنسلی و افت رتبه فروشندگی در مارکت‌پلیس‌ها",
        "سیستم خودترمیم تنوع‌های کالا و مدیریت هوشمند خطاها",
        "داشبورد مانیتورینگ بلادرنگ، لاگ‌های شفاف و رهگیری تمامی تبادلات"
      ],
      category: "پلتفرم",
      status: "بهره‌برداری کامل",
      teamSize: "تیم مهندسی آلتو",
      workingHours: "+۱۱۰۰ ساعت R&D"
    },
    coresell: {
      title: "سامانه مدیریت موجودی و قیمت‌گذاری چندکاناله کورسل",
      breadcrumb: "سامانه کورسل (CoreSell)",
      brandName: "CORESELL",
      website: "coresell.ir",
      dedicatedLink: "/coresell",
      description: "سامانه یکپارچه مدیریت موجودی، قیمت‌گذاری و انبارداری چندکاناله (CoreSell) حاصل ۷ ماه تحقیق و توسعه مهندسی متمرکز در استودیو آلتو. این سامانه به طور ریشه‌ای مشکل مغایرت موجودی بین کانال‌های فروش همزمان (دیجی‌کالا، باسلام، فروشگاه اختصاصی ووکامرس) و نوسانات قیمت را حل کرده است. کورسل با تکیه بر معماری توزیع‌شده مبتنی بر صف‌های هوشمند BullMQ و Redis، وب‌هوک‌های لحظه‌ای، الگوریتم‌های قیمت‌گذاری هوشمند بر اساس کمیسیون، انبارداری دسته‌ای با اکسل و افزونه اختصاصی وردپرس، فرآیند فروش را کاملاً خودکار و پایدار کرده است.",
      images: [
        "./image/coresell1.jpg",
        "./image/coresell2.jpg",
        "./image/coresell3.jpg"
      ],
      client: "محصول اختصاصی استودیو آلتو",
      duration: "۷ ماه (۱۴۰۴-۱۴۰۵)",
      location: "اصفهان، ایران",
      technologies: ["Node.js", "Express", "BullMQ", "Redis", "React", "Tailwind CSS", "MongoDB", "WooCommerce Plugin", "Digikala Marketplace API", "Basalam API", "ExcelJS"],
      features: [
        "همگام‌سازی ثانیه‌ای موجودی با دیجی‌کالا، باسلام و سایت شخصی",
        "قیمت‌گذاری خودکار و درصدی بر اساس کارمزد و کمیسیون هر درگاه",
        "انبارگردانی دسته‌ای سریع با بارگذاری مستقیم فایل اکسل",
        "معماری مقاوم با صف‌های توزیع‌شده Redis و BullMQ بدون قطعی در شرایط اختلال اینترنت",
        "افزونه اختصاصی وردپرس (Stock Sync) برای همگام‌سازی دوطرفه با ووکامرس",
        "پیشگیری قطعی از جریمه‌های کنسلی و افت رتبه فروشندگی در مارکت‌پلیس‌ها",
        "سیستم خودترمیم تنوع‌های کالا و مدیریت هوشمند خطاها",
        "داشبورد مانیتورینگ بلادرنگ، لاگ‌های شفاف و رهگیری تمامی تبادلات"
      ],
      category: "پلتفرم",
      status: "بهره‌برداری کامل",
      teamSize: "تیم مهندسی آلتو",
      workingHours: "+۱۱۰۰ ساعت R&D"
    },
    2: {
      title: "وبسایت کلینیک مشاوره نارون سبز",
      breadcrumb: "وبسایت کلینیک مشاوره نارون سبز",
      brandName: "NARVAN SABZ",
      website: "narvansabz.ir",
      description: "وبسایت تخصصی کلینیک مشاوره نارون سبز با طراحی حرفه‌ای و کاربردی. این پروژه شامل سیستم رزرو نوبت آنلاین، پنل ادمین جامع، مدیریت بیماران، سیستم پیام‌رسانی و گزارش‌گیری کامل می‌باشد. با رعایت کامل اصول محرمانگی و امنیت اطلاعات، محیطی امن برای بیماران و کادر درمان فراهم کرده است.",
      images: [
        "./image/narvanweb1.png",
        "./image/narvanweb2.png",
      
      
      ],
      client: "کلینیک مشاوره نارون سبز",
      duration: "تابستان ۱۴۰۲",
      location: "اصفهان، مجتمع پارک",
      technologies: ["Next.js", "Node.js", "MongoDB", "JWT", "Socket.io", "Tailwind CSS"],
      features: [
        "سیستم رزرو نوبت آنلاین",
        "پنل ادمین جامع",
        "مدیریت بیماران و پرونده‌ها",
        "سیستم پیام‌رسانی داخلی",
        "گزارش‌گیری و آمارگیری",
        "پشتیبانی چندزبانه",
        "سیستم اعلان‌ها",
        "امنیت بالا و رمزنگاری"
      ],
      category: "شرکتی",
      status: "تکمیل شده",
      teamSize: "4 نفر",
      workingHours: "280 ساعت"
    },
    3: {
      title: "اپ مدیریت کلینیک مشاوره",
      breadcrumb: "اپ مدیریت کلینیک مشاوره",
      brandName: "NARVAN SABZ APP",
      website: "app.narvansabz.ir",
      description: "اپلیکیشن وب پیشرفته (PWA) برای مدیریت کلینیک مشاوره نارون سبز. این اپلیکیشن قابلیت نصب بر روی تمامی دستگاه‌ها را دارد و با رعایت کامل محرمانگی اطلاعات، محیطی امن و کاربردی برای مدیریت کلینیک فراهم می‌کند. شامل سیستم‌های پیشرفته مدیریت نوبت‌ها، بیماران، مالی و گزارش‌گیری می‌باشد.",
      images: [
        "./image/narvan1.png",
        "./image/narvan2.png",
        "./image/narvan3.png",
       
      ],
      client: "کلینیک مشاوره نارون سبز",
      duration: "زمستان ۱۴۰۴",
      location: "اصفهان، مجتمع پارک",
      technologies: ["PWA", "React", "Node.js", "MongoDB", "Service Workers", "IndexedDB"],
      features: [
        "قابلیت نصب بر روی دستگاه‌ها",
        "کار آفلاین و همگام‌سازی",
        "مدیریت پیشرفته نوبت‌ها",
        "سیستم مالی و حسابداری",
        "گزارش‌گیری جامع",
        "امنیت بالا و رمزنگاری",
        "پشتیبانی از تمامی مرورگرها",
        "بهینه‌سازی برای موبایل"
      ],
      category: "PWA",
      status: "تکمیل شده",
      teamSize: "6 نفر",
      workingHours: "420 ساعت"
    },
    4: {
      title: "پلتفرم رفیتنس",
      breadcrumb: "پلتفرم رفیتنس",
      brandName: "RAFITNES",
      website: "rafitnes.com",
      description: "پلتفرم جامع مدیریت و برنامه‌ریزی تناسب اندام و رفیتنس. این پلتفرم شامل سیستم مدیریت کاربران، برنامه‌های تمرینی، رژیم‌های غذایی، پیگیری پیشرفت، چارت‌ها و گزارش‌های تحلیلی می‌باشد. با رابط کاربری مدرن و تجربه کاربری بهینه، ابزاری کامل برای مربیان و ورزشکاران فراهم می‌کند.",
      images: [
        "./image/rafitnes1.jpg",
        "./image/rafitnes2.jpg",
        "./image/rafitnes3.jpg",
        "./image/rafitnes4.jpg"
      ],
      client: "شرکت رفیتنس",
      duration: "زمستان ۱۴۰۳",
      location: "اصفهان، ایران",
      technologies: ["React", "TypeScript", "Vite", "Material-UI", "Node.js", "Express", "MongoDB", "JWT"],
      features: [
        "سیستم مدیریت کاربران و نقش‌ها",
        "برنامه‌ریزی تمرینات و رژیم غذایی",
        "پیگیری پیشرفت و آمار",
        "چارت‌ها و نمودارهای تحلیلی",
        "سیستم پیام‌رسانی",
        "پنل مدیریت جامع",
        "رابط کاربری مدرن و ریسپانسیو",
        "امنیت بالا و احراز هویت"
      ],
      category: "پلتفرم",
      status: "تکمیل شده",
      teamSize: "5 نفر",
      workingHours: "450 ساعت"
    },
    5: {
      title: "سایت فروشگاهی کاتن",
      breadcrumb: "سایت فروشگاهی کاتن",
      brandName: "KA10",
      website: "ka10.ir",
      description: "سایت فروشگاهی کاتن (ka10.ir) با قابلیت‌های کامل تجارت الکترونیک. شامل سیستم مدیریت محصولات، سبد خرید، پرداخت آنلاین، سیستم نظرات و امتیازدهی، مقایسه محصولات، و پنل مدیریت جامع. با استفاده از Next.js و بهینه‌سازی برای SEO، تجربه کاربری سریع و روانی را ارائه می‌دهد.",
      images: [
        "./image/ka10-1.jpg",
        "./image/ka10-2.jpg",
        "./image/ka10-3.jpg",
        "./image/ka10-4.jpg"
      ],
      client: "کاتن",
      duration: "پاییز ۱۴۰۳",
      location: "اصفهان، ایران",
      technologies: ["Next.js", "React", "Redux", "Bootstrap", "Node.js", "MongoDB", "Express"],
      features: [
        "سیستم فروش آنلاین کامل",
        "مقایسه محصولات",
        "سیستم نظرات و امتیازدهی",
        "بهینه‌سازی SEO",
        "پنل مدیریت پیشرفته",
        "سیستم پرداخت امن",
        "مدیریت موجودی و انبار",
        "گزارش‌گیری جامع",
        "اتصال به شبکه‌های اجتماعی"
      ],
      category: "فروشگاهی",
      status: "تکمیل شده",
      teamSize: "4 نفر",
      workingHours: "380 ساعت"
    },
    6: {
      title: "سایت فروشگاهی ایران هت",
      breadcrumb: "سایت فروشگاهی ایران هت",
      brandName: "IRAN HAT",
      website: "iranhat.com",
      description: "سایت فروشگاهی تخصصی برای فروش کلاه و محصولات مرتبط. این پروژه با طراحی مدرن و کاربرپسند، شامل سیستم مدیریت محصولات، فیلترهای پیشرفته، سبد خرید، پرداخت آنلاین، و پنل مدیریت می‌باشد. با استفاده از Next.js و Tailwind CSS، رابط کاربری زیبا و بهینه‌ای را ارائه می‌دهد.",
      images: [
        "./image/iranhat1.jpg",
        "./image/iranhat2.jpg",
        "./image/iranhat3.jpg",
        "./image/iranhat4.jpg"
      ],
      client: "ایران هت",
      duration: "تابستان ۱۴۰۳",
      location: "اصفهان، ایران",
      technologies: ["Next.js", "React", "Redux", "Tailwind CSS", "Node.js", "MongoDB", "Express"],
      features: [
        "سیستم فروش آنلاین",
        "فیلترهای پیشرفته محصولات",
        "سبد خرید و پرداخت آنلاین",
        "پنل مدیریت محصولات",
        "بهینه‌سازی برای موتورهای جستجو",
        "طراحی ریسپانسیو",
        "سیستم مدیریت موجودی",
        "گزارش‌گیری و آمار",
        "اتصال به شبکه‌های اجتماعی"
      ],
      category: "فروشگاهی",
      status: "تکمیل شده",
      teamSize: "4 نفر",
      workingHours: "350 ساعت"
    },
    7: {
      title: "سایت فروشگاهی کالای خواب و منسوجات بافتیکس",
      breadcrumb: "سایت فروشگاهی بافتیکس",
      brandName: "BAFTIX",
      website: "baftix.com",
      description: "فروشگاه آنلاین نسل جدید بافتیکس برای تولید و عرضه تخصصی انواع روفرشی کشدار، فرشینه مخمل، پرده و روتختی. پیاده‌سازی شده بر پایه اکوسیستم فروشگاهی پیشرفته آلتو (shop-test) با استفاده از Next.js 13، ری‌اکت و نودجی‌اس. این پلتفرم با امکان انتخاب هوشمند سایزها و متریال‌های سفارشی، محاسبه لحظه‌ای قیمت ابعاد غیراستاندارد، اتصال به درگاه‌های پرداخت اقساطی اسنپ‌پی و دیجی‌پی در ۴ قسط بدون ضامن، صدور خودکار فاکتور چاپی و بارکد انبارداری (PDF/QR)، سئو تکنیکال و پنل ادمین اختصاصی با قابلیت مدیریت کمپین‌ها و انبارداری چندگانه تجهیز شده است.",
      images: [
        "./image/baftix1.jpg",
        "./image/baftix2.jpg",
        "./image/baftix3.jpg"
      ],
      client: "مجموعه تولیدی و فروشگاهی بافتیکس",
      duration: "۱۴۰۴",
      location: "ایران",
      technologies: ["Next.js 13", "React 18", "Redux Toolkit", "Node.js (Express 5)", "MongoDB", "Tailwind CSS", "SnappPay API", "Digipay API", "PDFKit", "ExcelJS"],
      features: [
        "سیستم فروش آنلاین روفرشی کشدار، فرشینه و کالای خواب",
        "امکان انتخاب ابعاد سفارشی با محاسبه آنی قیمت",
        "خرید اقساطی ۴ ماهه اسنپ‌پی و دیجی‌پی بدون ضامن و چک",
        "صدور خودکار فاکتور رسمی چاپی و برچسب پستی با بارکد QR",
        "سرعت لود استثنایی و سئو ساختاریافته با Next.js Server-Side Rendering",
        "سبد خرید بهینه، لیست علاقه‌مندی و مقایسه هوشمند محصولات",
        "پنل مدیریت اختصاصی، سیستم تخفیف‌های زمان‌دار و گزارش‌های تحلیلی",
        "طراحی واکنش‌گرا و تجربه کاربری روان در موبایل"
      ],
      category: "فروشگاهی",
      status: "تکمیل شده",
      teamSize: "۴ نفر",
      workingHours: "۳۶۰ ساعت"
    },
    8: {
      title: "سایت فروشگاهی هپی وُرم",
      breadcrumb: "سایت فروشگاهی هپی وُرم",
      brandName: "HAPPY WORMS",
      website: "happy-worms.ir",
      description: "فروشگاه آنلاین هپی وُرم، پخش‌کننده میلورم خشک برای پرندگان، ماهی و لاک‌پشت. این سایت با امکان خرید سریع، نمایش سریع محصولات، سبد خرید، علاقه‌مندی و مقایسه، فروش خرده و عمده (از بسته‌های ۱۰ گرمی تا ۱۲ کیلویی) را پوشش می‌دهد. خرید قسطی با اسنپ‌پی، اشتراک خبرنامه و اتصال به شبکه‌های اجتماعی از دیگر قابلیت‌های این فروشگاه است.",
      images: [
        "./image/happy-worms1.jpg",
      ],
      client: "هپی وُرم",
      duration: "۱۴۰۴",
      location: "ایران",
      technologies: ["Next.js", "React", "Node.js", "MongoDB", "Express", "Tailwind CSS"],
      features: [
        "فروش خرده و عمده میلورم",
        "خرید سریع و نمایش سریع محصول",
        "سبد خرید و علاقه‌مندی",
        "مقایسه محصولات",
        "پرداخت امن و خرید قسطی (اسنپ‌پی)",
        "پنل مدیریت محصولات",
        "بهینه‌سازی SEO",
        "اتصال به شبکه‌های اجتماعی",
        "اشتراک خبرنامه برای تخفیف‌ها"
      ],
      category: "فروشگاهی",
      status: "تکمیل شده",
      teamSize: "4 نفر",
      workingHours: "340 ساعت"
    },
    9: {
      title: "فروشگاه آنلاین کتاب‌های آموزش زبان خارجی آوای دانش",
      breadcrumb: "سایت فروشگاهی آوای دانش",
      brandName: "AVAAY DANESH",
      website: "avaaydanesh.com",
      description: "فروشگاه آنلاین تخصصی آوای دانش برای فروش کتاب‌ها، رمان‌ها و مراجع آزمون‌های زبان‌های خارجی (انگلیسی، آلمانی، فرانسه، اسپانیایی، ترکی، ایتالیایی و مراجع آمادگی آزمون‌های بین‌المللی IELTS، TOEFL و گوته). پیاده‌سازی شده با پشته اختصاصی تجارت الکترونیک آلتو (shop-test). این سیستم مجهز به فیلترهای چندلایه بر اساس سطوح استاندارد بین‌المللی اروپا (CEFR: A1 تا C2)، مهارت‌های زبانی (شنیداری، گفتاری، خواندن، نگارش)، موتور جستجوی فوری، امکان پیش‌نمایش صفحات و نمونه‌های صوتی، و تخفیف‌های پلکانی برای آموزشگاه‌ها و زبان‌آموزان است.",
      images: [
        "./image/avaaydanesh1.jpg",
        "./image/avaaydanesh2.jpg",
        "./image/avaaydanesh3.jpg"
      ],
      client: "مرکز زبان و کتاب آوای دانش",
      duration: "۱۴۰۴",
      location: "ایران",
      technologies: ["Next.js 13", "React 18", "Redux Toolkit", "Node.js (Express 5)", "MongoDB", "Tailwind CSS", "Zarinpal Gateway", "Mellat Gateway", "REST API"],
      features: [
        "فیلترینگ تخصصی بر اساس سطح زبان (A1, A2, B1, B2, C1, C2) و مهارت",
        "موتور جستجوی بلادرنگ در هزاران عنوان کتاب، نویسندگان و ناشران بین‌المللی",
        "سیستم فروش با تخفیف‌های ویژه دانش‌آموزی و خرید عمده آموزشگاه‌ها",
        "پیش‌نمایش صفحات کتاب و امکان دانلود فایل‌های صوتی نمونه",
        "سرعت لود بسیار بالا و سئو اختصاصی دسته‌بندی‌های آموزشی",
        "پنل مدیریت محصولات کتابی با قابلیت مدیریت ناشران و مشخصات چاپ",
        "طراحی واکنش‌گرا، پرداخت امن آنلاین و پیگیری پستی مرسولات"
      ],
      category: "فروشگاهی",
      status: "تکمیل شده",
      teamSize: "۴ نفر",
      workingHours: "۳۵۰ ساعت"
    },
    10: {
      title: "سامانه هوشمند مدیریت جامع مدارس و مراکز آموزشی مدار",
      breadcrumb: "سامانه مدیریت مدارس مدار",
      brandName: "MADAR EDU",
      website: "app.madaredu.ir",
      description: "پلتفرم ابری چندمستاجره (Multi-Tenant SaaS) مدیریت هوشمند مدارس مدار که بر پایه معماری پروژه LMS آلتو توسعه یافته است. سامانه مدار کلیه فرآیندهای آموزشی، اداری و نظارتی مدارس را یکپارچه و تمام‌دیجیتال کرده است: از ثبت‌نام الکترونیک، گروه‌بندی کلاسی، حضور و غیاب آنلاین با ارسال خودکار پیامک غیبت به اولیا، دفتر کلاسی هوشمند معلمان، ثبت نمرات مستمر و توصیفی، تا صدور اتوماتیک کارنامه‌های تحلیلی و نموداری، ماژول انضباطی، آزمون‌های آنلاین و پورتال‌های تفکیک‌شده برای مدیر، دبیر، دانش‌آموز و اولیا.",
      images: [
        "./image/madaredu1.jpg",
        "./image/madaredu2.jpg",
        "./image/madaredu3.jpg"
      ],
      client: "سامانه هوشمند مدارس مدار",
      duration: "۱۴۰۳-۱۴۰۴",
      location: "ایران",
      technologies: ["React 18", "Node.js", "Express", "MongoDB", "Tailwind CSS", "PWA", "SMS Gateway", "Chart.js", "Multi-Tenant Architecture"],
      features: [
        "معماری ابری چندمستاجره (Multi-Tenant SaaS) مناسب مجتمع‌های آموزشی و شعب",
        "حضور و غیاب الکترونیک هوشمند با اطلاع‌رسانی لحظه‌ای پیامکی به والدین",
        "دفتر کلاسی دیجیتال معلمان و ثبت نمرات مستمر، کمی و توصیفی",
        "صدور خودکار کارنامه با نمودارهای پیشرفت تحصیلی و تحلیل آماری",
        "۴ پورتال مستقل برای مدیران، معلمان، دانش‌آموزان و اولیا",
        "قابلیت نصب به عنوان Progressive Web App (PWA) با سرعت و کاربری آسان",
        "ماژول پرونده انضباطی، تشویق‌ها و سیستم پیام‌رسانی داخلی",
        "ماژول برگزاری آزمون‌های کلاسی و آنلاین و تحلیل نتایج"
      ],
      category: "پلتفرم",
      status: "تکمیل شده",
      teamSize: "۵ نفر",
      workingHours: "۴۸۰ ساعت"
    }
  };

  const project = projectData[id] || projectData[2];

  useEffect(() => {
    setIsLoading(true);
    const timer = setTimeout(() => setIsLoading(false), 1000);
    return () => clearTimeout(timer);
  }, [id]);

  if (isLoading) {
    return (
      <div className="min-h-screen bg-slate-900 flex items-center justify-center">
        <div className="text-center">
          <div className="w-16 h-16 border-4 border-teal-500 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-slate-300 text-xl">در حال بارگذاری...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-slate-900">
      <Header />
      
      {/* Hero Section */}
      <div className="relative h-80 sm:h-96 overflow-hidden">
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{ backgroundImage: `url(${project.images[0]})` }}
        >
          <div className="absolute inset-0 bg-gradient-to-t from-slate-900 via-slate-900/70 to-slate-900/40" />
        </div>
        
        <div className="relative z-10 h-full flex items-center">
          <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
            <nav className="text-sm mb-6">
              <ol className="flex items-center space-x-reverse space-x-2">
                <li><Link to="/" className="text-slate-400 hover:text-teal-400 transition-colors">خانه</Link></li>
                <li className="text-slate-500">/</li>
                <li><span className="text-white font-medium">{project.breadcrumb}</span></li>
              </ol>
            </nav>
            
            <div className="text-white">
              <span className="inline-block text-teal-400 text-sm font-medium bg-teal-500/20 px-3 py-1 rounded-lg mb-4">
                {project.category}
              </span>
              <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-3 leading-tight">
                {project.title}
              </h1>
              <p className="text-slate-300 text-lg max-w-2xl leading-relaxed">
                {project.description.substring(0, 120)}...
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Project Showcase */}
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-10">
          <div className="lg:col-span-2">
            <div className="relative group">
              <div className="relative overflow-hidden rounded-xl border border-slate-700/50 shadow-xl">
                <img
                  src={project.images[activeImage]} onError={(e) => { e.currentTarget.onerror = null; e.currentTarget.src = "./image/project.png"; }}
                  alt={`${project.brandName} — اسلاید ${activeImage + 1}`}
                  className="w-full h-80 md:h-[420px] object-cover transition-all duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-slate-900/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                <button
                  onClick={() => setActiveImage(activeImage > 0 ? activeImage - 1 : project.images.length - 1)}
                  className="absolute left-3 top-1/2 -translate-y-1/2 w-10 h-10 bg-slate-800/90 backdrop-blur rounded-full flex items-center justify-center text-white hover:bg-teal-600 transition-all opacity-0 group-hover:opacity-100"
                >
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" /></svg>
                </button>
                <button
                  onClick={() => setActiveImage(activeImage < project.images.length - 1 ? activeImage + 1 : 0)}
                  className="absolute right-3 top-1/2 -translate-y-1/2 w-10 h-10 bg-slate-800/90 backdrop-blur rounded-full flex items-center justify-center text-white hover:bg-teal-600 transition-all opacity-0 group-hover:opacity-100"
                >
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" /></svg>
                </button>
              </div>
              <div className="flex space-x-reverse space-x-3 mt-4 overflow-x-auto pb-1">
                {project.images.map((img, idx) => (
                  <button
                    key={idx}
                    onClick={() => setActiveImage(idx)}
                    className={`flex-shrink-0 w-16 h-12 rounded-lg overflow-hidden border-2 transition-all ${
                      activeImage === idx ? 'border-teal-500 shadow-md shadow-teal-500/20' : 'border-slate-600 hover:border-slate-500'
                    }`}
                  >
                    <img src={img} alt="" onError={(e) => { e.currentTarget.onerror = null; e.currentTarget.src = "./image/project.png"; }} className="w-full h-full object-cover" />
                  </button>
                ))}
              </div>
            </div>
          </div>

          <div className="lg:col-span-1 space-y-4">
            <div className="bg-teal-600/20 border border-teal-500/30 text-teal-300 p-4 rounded-xl text-center">
              <div className="w-10 h-10 bg-teal-500/30 rounded-full flex items-center justify-center mx-auto mb-2">
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
              </div>
              <h3 className="font-bold text-white">{project.status}</h3>
              <p className="text-sm text-teal-200/90">پروژه با موفقیت تکمیل شده</p>
            </div>

            <div className="space-y-3">
              <div className="bg-slate-800/80 rounded-xl p-4 border border-slate-700/50">
                <div className="flex items-center space-x-reverse space-x-3">
                  <div className="w-10 h-10 bg-teal-500/20 rounded-lg flex items-center justify-center flex-shrink-0">
                    <svg className="w-5 h-5 text-teal-400" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" /></svg>
                  </div>
                  <div><h4 className="font-semibold text-white text-sm">کارفرما</h4><p className="text-slate-400 text-sm">{project.client}</p></div>
                </div>
              </div>
              <div className="bg-slate-800/80 rounded-xl p-4 border border-slate-700/50">
                <div className="flex items-center space-x-reverse space-x-3">
                  <div className="w-10 h-10 bg-teal-500/20 rounded-lg flex items-center justify-center flex-shrink-0">
                    <svg className="w-5 h-5 text-teal-400" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
                  </div>
                  <div><h4 className="font-semibold text-white text-sm">مدت زمان</h4><p className="text-slate-400 text-sm">{project.duration}</p></div>
                </div>
              </div>
              <div className="bg-slate-800/80 rounded-xl p-4 border border-slate-700/50">
                <div className="flex items-center space-x-reverse space-x-3">
                  <div className="w-10 h-10 bg-teal-500/20 rounded-lg flex items-center justify-center flex-shrink-0">
                    <svg className="w-5 h-5 text-teal-400" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" /><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" /></svg>
                  </div>
                  <div><h4 className="font-semibold text-white text-sm">موقعیت</h4><p className="text-slate-400 text-sm">{project.location}</p></div>
                </div>
              </div>
            </div>

            <div className="space-y-2">
              {project.dedicatedLink && (
                <Link to={project.dedicatedLink} className="w-full bg-gradient-to-r from-teal-500 to-emerald-500 hover:from-teal-400 hover:to-emerald-400 text-slate-950 py-3 px-4 rounded-xl font-bold transition-all flex items-center justify-center gap-2 text-sm shadow-lg shadow-teal-500/20 mb-2">
                  <span className="relative flex h-2 w-2">
                    <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-slate-950 opacity-75"></span>
                    <span className="relative inline-flex rounded-full h-2 w-2 bg-slate-950"></span>
                  </span>
                  مشاهده صفحه اختصاصی و معرفی جامع کورسل
                </Link>
              )}
              <a href={`https://${project.website}`} target="_blank" rel="noopener noreferrer" className="w-full bg-teal-600 hover:bg-teal-500 text-white py-3 px-4 rounded-xl font-medium transition-all flex items-center justify-center gap-2 text-sm">
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" /></svg>
                مشاهده زنده سایت
              </a>
              <Link to="/" className="w-full bg-slate-800 border border-slate-600 text-slate-300 hover:border-teal-500/50 hover:text-teal-400 py-3 px-4 rounded-xl font-medium transition-all flex items-center justify-center gap-2 text-sm">
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" /></svg>
                بازگشت به نمونه‌کارها
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* Project Details */}
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-10">
          <div className="lg:col-span-2 space-y-8">
            <div className="bg-slate-800/80 rounded-xl p-6 border border-slate-700/50">
              <h2 className="text-xl font-bold text-white mb-4 flex items-center gap-2">
                <span className="w-8 h-8 bg-teal-500/20 rounded-lg flex items-center justify-center">
                  <svg className="w-4 h-4 text-teal-400" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" /></svg>
                </span>
                درباره پروژه
              </h2>
              <p className="text-slate-400 leading-relaxed">
                {project.description}
              </p>
            </div>

            <div className="bg-slate-800/80 rounded-xl p-6 border border-slate-700/50">
              <h3 className="text-lg font-bold text-white mb-4 flex items-center gap-2">
                <span className="w-8 h-8 bg-teal-500/20 rounded-lg flex items-center justify-center">
                  <svg className="w-4 h-4 text-teal-400" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4" /></svg>
                </span>
                تکنولوژی‌ها
              </h3>
              <div className="flex flex-wrap gap-2">
                {project.technologies.map((tech, index) => (
                  <span key={index} className="bg-slate-700/80 text-teal-300 px-3 py-1.5 rounded-lg text-sm font-medium border border-slate-600">
                    {tech}
                  </span>
                ))}
              </div>
            </div>

            <div className="bg-slate-800/80 rounded-xl p-6 border border-slate-700/50">
              <h3 className="text-lg font-bold text-white mb-4 flex items-center gap-2">
                <span className="w-8 h-8 bg-teal-500/20 rounded-lg flex items-center justify-center">
                  <svg className="w-4 h-4 text-teal-400" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
                </span>
                ویژگی‌ها
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                {project.features.map((feature, index) => (
                  <div key={index} className="flex items-center gap-2 p-3 bg-slate-700/50 rounded-lg border border-slate-600/50">
                    <div className="w-5 h-5 bg-teal-500/30 rounded-full flex items-center justify-center flex-shrink-0">
                      <svg className="w-3 h-3 text-teal-400" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" /></svg>
                    </div>
                    <span className="text-slate-300 text-sm">{feature}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="lg:col-span-1 space-y-4">
            <div className="bg-slate-800/80 border border-teal-500/20 rounded-xl p-5">
              <h3 className="text-lg font-bold text-white mb-4">آمار پروژه</h3>
              <div className="space-y-3 text-sm">
                <div className="flex justify-between"><span className="text-slate-400">صفحات</span><span className="text-white font-medium">{project.category === 'PWA' ? '25' : project.category === 'شرکتی' ? '18' : '15'}</span></div>
                <div className="flex justify-between"><span className="text-slate-400">ساعات کاری</span><span className="text-white font-medium">{project.workingHours}</span></div>
                <div className="flex justify-between"><span className="text-slate-400">تیم</span><span className="text-white font-medium">{project.teamSize}</span></div>
                <div className="flex justify-between"><span className="text-slate-400">رضایت</span><span className="text-teal-400 font-medium">100%</span></div>
              </div>
            </div>

            <div className="bg-slate-800/80 rounded-xl p-5 border border-slate-700/50">
              <h3 className="text-lg font-bold text-white mb-3">اشتراک‌گذاری</h3>
              <div className="flex gap-2">
                <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="flex-1 bg-slate-700 hover:bg-teal-600 text-slate-300 hover:text-white py-2.5 rounded-lg flex items-center justify-center transition-colors">
                  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z"/></svg>
                </a>
                <a href="https://wa.me/09134378347" target="_blank" rel="noopener noreferrer" className="flex-1 bg-slate-700 hover:bg-teal-600 text-slate-300 hover:text-white py-2.5 rounded-lg flex items-center justify-center transition-colors">
                  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.885 3.488"/></svg>
                </a>
                <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="flex-1 bg-slate-700 hover:bg-teal-600 text-slate-300 hover:text-white py-2.5 rounded-lg flex items-center justify-center transition-colors">
                  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/></svg>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Related Projects */}
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-12 border-t border-slate-800">
        <div className="text-center mb-10">
          <h2 className="text-2xl font-bold text-white mb-2">پروژه‌های مرتبط</h2>
          <p className="text-slate-400 text-sm">نمونه کارهای مشابه</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {Object.entries(projectData)
            .filter(([key]) => key !== id)
            .map(([key, relatedProject]) => (
              <Link key={key} to={`/project/${key}`} className="group block bg-slate-800/80 rounded-xl overflow-hidden border border-slate-700/50 hover:border-teal-500/30 hover:-translate-y-1 transition-all duration-300">
                <div className="relative aspect-video overflow-hidden">
                  <img src={relatedProject.images[0]} alt={relatedProject.title} onError={(e) => { e.currentTarget.onerror = null; e.currentTarget.src = "./image/project.png"; }} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                  <div className="absolute inset-0 bg-gradient-to-t from-slate-900/80 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
                  <span className="absolute top-3 right-3 text-xs font-medium text-teal-400 bg-slate-800/90 px-2 py-1 rounded">{relatedProject.category}</span>
                </div>
                <div className="p-4">
                  <h3 className="font-semibold text-white mb-1 group-hover:text-teal-400 transition-colors">{relatedProject.title}</h3>
                  <p className="text-slate-400 text-sm mb-3 overflow-hidden max-h-10">{relatedProject.description.substring(0, 80)}...</p>
                  <span className="text-teal-400 text-sm font-medium">مشاهده پروژه ←</span>
                </div>
              </Link>
            ))}
        </div>
      </div>

      {/* Comment Section */}
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-12 border-t border-slate-800">
        <div className="bg-slate-800/80 rounded-xl p-6 border border-slate-700/50">
          <div className="text-center mb-6">
            <h2 className="text-xl font-bold text-white mb-2">نظر شما درباره این پروژه</h2>
            <p className="text-slate-400 text-sm">تجربه و نظرات خود را با ما به اشتراک بگذارید</p>
          </div>
          <form className="space-y-4">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label htmlFor="name" className="block text-sm font-medium text-slate-300 mb-1">نام و نام خانوادگی</label>
                <input type="text" id="name" className="w-full px-4 py-2.5 bg-slate-700/50 border border-slate-600 rounded-lg text-white placeholder-slate-500 focus:ring-2 focus:ring-teal-500 focus:border-transparent" placeholder="نام شما" />
              </div>
              <div>
                <label htmlFor="email" className="block text-sm font-medium text-slate-300 mb-1">ایمیل</label>
                <input type="email" id="email" className="w-full px-4 py-2.5 bg-slate-700/50 border border-slate-600 rounded-lg text-white placeholder-slate-500 focus:ring-2 focus:ring-teal-500 focus:border-transparent" placeholder="ایمیل شما" />
              </div>
            </div>
            <div>
              <label htmlFor="comment" className="block text-sm font-medium text-slate-300 mb-1">نظر شما</label>
              <textarea id="comment" rows={4} className="w-full px-4 py-2.5 bg-slate-700/50 border border-slate-600 rounded-lg text-white placeholder-slate-500 focus:ring-2 focus:ring-teal-500 focus:border-transparent resize-none" placeholder="نظر خود را بنویسید..." />
            </div>
            <div className="flex items-center justify-center gap-2">
              <span className="text-sm text-slate-400">امتیاز:</span>
              <div className="flex gap-1">
                {[1, 2, 3, 4, 5].map((star) => (
                  <button key={star} type="button" className="text-slate-500 hover:text-teal-400 transition-colors">
                    <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" /></svg>
                  </button>
                ))}
              </div>
            </div>
            <div className="text-center pt-2">
              <button type="submit" className="bg-teal-600 hover:bg-teal-500 text-white py-3 px-6 rounded-lg font-medium transition-colors">
                ارسال نظر
              </button>
            </div>
          </form>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default ProjectDetailPage;